import { useMemo } from "react";

import type { GoogleFreeBookingLinksSettingsI18nQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandContainer } from "@/components/features/_layouts";

import { GoogleFreeBookingLinksSettingsI18nContext } from "./_context";
import { Form } from "./form";
import { Header } from "./header";
import { useGoogleFreeBookingLinksSettingsI18nForm } from "../../hooks";

import type { GoogleFreeBookingLinksSettingsI18nContextType } from "./_context";

type Props = {
	googleFreeBookingLinksSettingsI18nQueryData: GoogleFreeBookingLinksSettingsI18nQuery;
};

export const FormGoogleFreeBookingLinksIslandSettingsI18n = ({
	googleFreeBookingLinksSettingsI18nQueryData: { googleFreeBookingLinksSettingsI18n },
}: Props) => {
	const form = useGoogleFreeBookingLinksSettingsI18nForm({
		googleFreeBookingLinksSettingsI18n,
	});

	const initialContextValue: GoogleFreeBookingLinksSettingsI18nContextType = useMemo(() => {
		return {
			form,
		};
	}, [form]);

	useTransitionBlock(form.formState.isDirty);

	return (
		<GoogleFreeBookingLinksSettingsI18nContext.Provider value={initialContextValue}>
			<FeatureIslandContainer>
				<Header />
				<Form />
			</FeatureIslandContainer>
		</GoogleFreeBookingLinksSettingsI18nContext.Provider>
	);
};
